import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "joinWith",
    standalone: false
})
export class JoinWithPipe implements PipeTransform {
    transform(words: string[], separator: string): string {
        if (!words || !Array.isArray(words)) return words as any;
        return `${words.join(separator)}${separator}`;
    }
}
